import Card from "PFComponents/card/card";
import { LoadingDots } from "PFComponents/loading_dots";
import { useMarketplaceActivity } from "PFCore/hooks/queries/activities/marketplace/use_marketplace_activity";
import React from "react";

import { useMarketplaceContext } from "../../../contexts/marketplace_context";
import {
  CoreInformationSection,
  CustomFieldsSection,
  DescriptionSection,
  Header,
  InterestQuestionsSection,
  OwnersSection,
  PrivacySection,
  SkillsSection,
  StatementSection,
  StatsSection
} from "./parts";
import css from "./role_details.module.scss";

export const RoleDetails = (): JSX.Element => {
  const { selectedRoleId } = useMarketplaceContext();
  const { isLoading, data: role } = useMarketplaceActivity(selectedRoleId!, {
    enabled: selectedRoleId !== null
  });

  const displayRoleDetails = !isLoading && role;

  return (
    <Card rootClassName={css.card} shadowType="pfOriginal">
      {isLoading && (
        <div className={css.loadingWrapper}>
          <LoadingDots circlesEnabled circleSize="xs" />
        </div>
      )}

      {displayRoleDetails && (
        <div>
          <Header role={role} />
          <CoreInformationSection role={role} />
          <OwnersSection role={role} />
          <DescriptionSection role={role} />
          <InterestQuestionsSection role={role} />
          <StatementSection role={role} />
          <SkillsSection role={role} />
          <CustomFieldsSection role={role} />
          <PrivacySection role={role} />
          <StatsSection role={role} />
        </div>
      )}
    </Card>
  );
};
